import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import AWS from "aws-sdk";
import { decodeHtmlEntitiesDeep } from "util/CommonFunc";

export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ALBUM_LOAD: "ALBUM_LOAD" + module,
  ALBUM_TRACK_LOAD: "ALBUM_TRACK_LOAD" + module,
  ERROR: "ERROR" + module,
  INVOKE_OK: "INVOKE_OK" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  QUERY: "QUERY" + module,
  EDIT_ITEM: "EDIT_ITEM" + module,
  ALBUM_EDIT_ITEM: "ALBUM_EDIT_ITEM" + module,
  COMMON_EDIT_ITEM: "COMMON_EDIT_ITEM" + module,
  ALBUM_COMMON_EDIT_ITEM: "ALBUM_COMMON_EDIT_ITEM" + module,
  JOB_EDIT_ITEM: "JOB_EDIT_ITEM" + module,
  BULK_EDIT_SAVING: "BULK_EDIT_SAVING" + module,
  POSTING: "POSTING" + module,
  POST_OK_MESSAGE: "POST_OK_MESSAGE" + module,
  POST_OK: "POST_OK" + module,
  IMAGE_POST_OK: "IMAGE_POST_OK" + module,
  GET_COUNTRIES: "GET_COUNTRIES" + module,
  GET_ORIGINS: "GET_ORIGINS" + module,
  GET_DECADES: "GET_DECADES" + module,
  GET_VOCALS: "GET_VOCALS" + module,
  POST_ERROR: "POST_ERROR" + module,
  STOP_ERROR: "STOP_ERROR" + module,
  SET_ERROR: "SET_ERROR" + module,
  POST_PUBLISH: "POST_PUBLISH" + module,
  VALIDATION_ITEM: "VALIDATION_ITEM" + module,
  CURRENT_TRACK_ID: "CURRENT_TRACK_ID" + module,
  CURRENT_ALBUM_ID: "CURRENT_ALBUM_ID" + module,
  ALBUM_TYPES: "ALBUM_TYPES" + module,
  TRACK_DATA: "TRACK_DATA" + module,
  ALBUM_DATA: "ALBUM_DATA" + module,
};

var tId = null;

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};

export const commonEditItem = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.COMMON_EDIT_ITEM,
    payload: items,
  });
};

export const albumEditItem = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.ALBUM_EDIT_ITEM,
    payload: items,
  });
};

export const albumCommonEditItem = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.ALBUM_COMMON_EDIT_ITEM,
    payload: items,
  });
};

export const jobEditItems = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.JOB_EDIT_ITEM,
    payload: item,
  });
};

export const getValidationItems = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.VALIDATION_ITEM,
    payload: item,
  });
};

export const setQuery =
  (query, done = null) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.QUERY,
      payload: query,
    });

    if (done) done();
  };

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const showAutoMessage = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.POST_OK_MESSAGE,
    });
  }, 3000);
};

export const setErrorMessage = (message) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_ERROR,
    payload: message,
  });
  setTimeout(() => {
    dispatch({
      type: actionTypes.STOP_ERROR,
    });
  }, 3000);
};

export const createAlbumBulkEdit =
  (items, done = null) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.LOADING,
      });

      const {
        user: {
          credentials: { orgID },
        },
      } = store.getState();
      const tId = uuidv4();

      const res = await axios.post(
        `${orgID}/bulkedit/jobs/album/create`,
        items,
        {
          headers: { tid: tId, orgid: orgID },
        }
      );
      dispatch({
        type: actionTypes.BULK_EDIT_SAVING,
        payload: res.data,
      });

      if (done) {
        done(res.data.job_id, null);
      }
    } catch (err) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data.e
          ? err.response.data.e
          : "Error in album creating or updating. please retry",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const createTrackBulkEdit =
  (items, done = null) =>
  async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.LOADING,
      });

      const {
        user: {
          credentials: { orgID },
        },
      } = store.getState();
      const tId = uuidv4();
      const res = await axios.post(
        `${orgID}/bulkedit/jobs/track/create`,
        items,
        {
          headers: { tid: tId, orgid: orgID },
        }
      );
      dispatch({
        type: actionTypes.BULK_EDIT_SAVING,
        payload: res.data,
      });

      if (done) {
        done(res.data.job_id, null);
      }
    } catch (err) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data.e
          ? err.response.data.e
          : "Error in track creating or updating. please retry",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const bulkEditInvoke =
  (items, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.LOADING,
      });
      const tId = uuidv4();
      const res = await axios.post(
        `${items.org_id}/bulkedit/jobs/invoke/${items.job_id}`,
        null,
        {
          headers: { tid: tId, orgid: items.org_id, Authorization: `${token}` },
        }
      );
      dispatch({
        type: actionTypes.INVOKE_OK,
        payload: decodeHtmlEntitiesDeep(res.data),
      });
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data.e
          ? err.response.data.e || {
              e: err.message ? err.message : "Error in invoke. please retry",
            }
          : "Error in invoke. please retry",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const search =
  (query, item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    const tId = uuidv4();
    dispatch({
      type: actionTypes.LOADING,
    });
    dispatch({
      type: actionTypes.CURRENT_TRACK_ID,
      payload: query.filters[0].value[0],
    });
    try {
      const res = await axios.post(`/librarysearch`, query, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });

      if (res.data.tid === tId) {
        if (
          res.data &&
          res.data.data &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          const data = res.data.data[0];

          if (data) {
            dispatch({
              type: actionTypes.LOAD,
              payload: data,
            });
          }
          if (Array.isArray(res.data.data)) {
            const prodIds = res.data.data.map((record) => record.prodId);
            dispatch({
              type: actionTypes.ALBUM_TRACK_LOAD,
              payload: prodIds,
            });
          }
        } else {
          dispatch({
            type: actionTypes.TRACK_DATA,
          });
        }

        if (done) done(res.data.data[0], null);
      }
    } catch (err) {
      console.log("err", err);
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    }
  };

export const albumSearch =
  (query, item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    const tId = uuidv4();
    dispatch({
      type: actionTypes.LOADING,
    });
    dispatch({
      type: actionTypes.CURRENT_ALBUM_ID,
      payload: query.filters[0].value[0],
    });
    try {
      const res = await axios.post(`/albumserach`, query, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });

      if (res.data.tid === tId) {
        if (
          res.data &&
          res.data.data &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          dispatch({
            type: actionTypes.ALBUM_LOAD,
            payload: res.data.data[0],
          });
          if (done) done(res.data.data[0], null);
        } else {
          dispatch({
            type: actionTypes.ALBUM_DATA,
          });
          if (done) done(null, new Error("No album data found"));
        }
      }
    } catch (err) {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });

      if (done) done(null, err);
    }
  };

export const bulkEditSave =
  (Items, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.POST_OK_MESSAGE,
        payload: "Bulk-Edit Saving...",
      });
      const tId = uuidv4();
      const res = await axios.post(
        `${Items.org_id}/bulkedit/jobs/save/${Items.job_id}`,
        Items.job,
        {
          headers: { tid: tId, orgid: Items.org_id, Authorization: `${token}` },
        }
      );

      setTimeout(() => {
        dispatch({
          type: actionTypes.POST_OK,
          payload: res.data,
        });
      }, 1000);
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: "Error in bulk edit saving. please retry",
        // payload: err?.response?.data?.e? (err.response.data.e.track_common_updates
        //   ||err.response.data.e.track_specific_updates
        //   ||err.response.data.e.album_common_updates
        //   ||err.response.data.e.album_specific_updates
        // ) : err?.response?.data?  err.response.data : "Error in bulk edit saving . please retry"
      });

      setTimeout(() => {
        dispatch({ type: actionTypes.STOP_ERROR });
      }, 3500);

      if (done) {
        done(null, err);
      }
    }
  };

export const bulkEditPublish =
  (message, job_id, orgId, done = null) =>
  async (dispatch) => {
    const tId = uuidv4();
    const token = localStorage.auth0IdToken;
    dispatch({
      type: actionTypes.POSTING,
      payload: message,
    });

    try {
      const res = await axios.post(
        `${orgId}/bulkedit/jobs/publish/${job_id}`,
        null,
        {
          headers: { tid: tId, orgid: orgId, Authorization: `${token}` },
        }
      );

      setTimeout(() => {
        dispatch({
          type: actionTypes.POST_OK_MESSAGE,
          payload: "Successfully published bulk-edited data",
        });
      }, 2000);

      setTimeout(() => {
        window.close();
        window.history.back();
        dispatch({
          type: actionTypes.POST_PUBLISH,
        });
      }, 4500);

      if (done) done(res.data, null);
    } catch (err) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: "Error in publishing. please retry",
        // payload: err.response?.data || {
        //   e: err.message
        //     ? err.message
        //     : "Error in publishing. please retry",
        // },
      });

      if (done) done(null, err);
    }
  };

export const bulkEditUploadImage =
  (data, id, image_type, orgId, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
        const {
          orgRuntime: { _contentS3Region },
        } = store.getState();
    try {
      dispatch({
        type: actionTypes.LOADING,
        payload: "Bulk-Edit Image Uploading...",
      });
      const tId = uuidv4();
      const imageTypeMatch = data.match(/^data:image\/(png|jpeg|gif);base64,/);
      if (!imageTypeMatch) {
        throw new Error("Invalid image data");
      }
      const res = await axios.post(
        `${orgId}/bulkedit/upload-album-artwork`,
        {
          s3_id: id,
          image_type: image_type,
        },
        {
          headers: { tid: tId, orgid: orgId, Authorization: `${token}` },
        }
      );

      const { credentials, bucketName, folder, region } = res.data;

      const base64Data = data.replace(
        /^data:image\/(png|jpeg|gif);base64,/,
        ""
      );
      const binaryData = Buffer.from(base64Data, "base64");

      const s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: {
          Bucket: bucketName,
          Key: `${folder}/ALBUM_CREATE_ARTWORK/${id}.${image_type}`,
          ContentType: `image/${image_type}`,
        },
        credentials: {
          accessKeyId: credentials.AccessKeyId,
          secretAccessKey: credentials.SecretAccessKey,
          sessionToken: credentials.SessionToken,
        },
        region: region || _contentS3Region,
      });

      const uploadParams = {
        Body: binaryData,
      };

      const uploadResult = await s3.upload(uploadParams).promise();

      const artworkUrl = uploadResult.Location;

      dispatch({
        type: actionTypes.IMAGE_POST_OK,
        payload: artworkUrl,
      });

      if (done) done({ url: artworkUrl }, null);
    } catch (err) {
      console.log(err);
      console.log(err?.response?.data.e);

      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err?.response?.data.e
          ? err.response.data.e || {
              e: err.message
                ? err.message
                : "Error in Processing BulkEdit. please retry",
            }
          : "Error in Processing BulkEdit. please retry",
      });

      setTimeout(() => {
        dispatch({ type: actionTypes.STOP_ERROR });
      }, 2000);

      if (done) {
        done(null, err);
      }
    }
  };

export const getListOfCountries =
  (item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.LOADING,
      });
      const tId = uuidv4();
      const res = await axios.get(`${item.org_id}/bulkedit/countries`, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });
      dispatch({
        type: actionTypes.GET_COUNTRIES,
        payload: res.data,
      });
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data
          ? err.response.data
          : "Error while retrieving countries. Please retry.",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const getListOfOrigins =
  (item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.LOADING,
      });
      const tId = uuidv4();
      const res = await axios.get(`${item.org_id}/bulkedit/origins`, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });
      dispatch({
        type: actionTypes.GET_ORIGINS,
        payload: res.data,
      });
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data
          ? err.response.data
          : "Error while retrieving origins. Please retry.",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const getListOfDecades =
  (item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.LOADING,
      });
      const tId = uuidv4();
      const res = await axios.get(`${item.org_id}/bulkedit/decades`, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });
      dispatch({
        type: actionTypes.GET_DECADES,
        payload: res.data,
      });
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data
          ? err.response.data
          : "Error while retrieving decades. Please retry.",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const getListOfVocals =
  (item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    try {
      dispatch({
        type: actionTypes.LOADING,
      });
      const tId = uuidv4();
      const res = await axios.get(`${item.org_id}/bulkedit/vocals`, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });
      dispatch({
        type: actionTypes.GET_VOCALS,
        payload: res.data,
      });
      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data
          ? err.response.data
          : "Error while retrieving vocals. Please retry.",
      });

      if (done) {
        done(null, err);
      }
    }
  };

export const getListOfAlbumTypes =
  (item, done = null) =>
  async (dispatch) => {
    const token = localStorage.auth0IdToken;
    const tId = uuidv4();
    try {
      dispatch({
        type: actionTypes.LOADING,
      });

      const res = await axios.get(`${item.org_id}/bulk-create/album-types`, {
        headers: { tid: tId, orgid: item.org_id, Authorization: `${token}` },
      });

      dispatch({
        type: actionTypes.ALBUM_TYPES,
        payload: res.data,
      });

      if (done) {
        done(res.data, null);
      }
    } catch (err) {
      console.log(err);

      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data
          ? err.response.data
          : "Error while retrieving Album Types. Please retry.",
      });

      if (done) {
        done(null, err);
      }
    }
  };
